export enum ESignUpSteps {
	Form = 'Form',
	Video = 'Video',
	Dashboard = 'Dashboard',
}
